import { applyTheme } from "./slide-themes";

// Raw slide data - just content, no styling
const nxmapSlidesData = [
  {
    id: "nxmap-overview",
    image: "/sliders/nxmap/1_nxmap.png",
    imageAlt: "NXMap platform overview",
    imagePosition: "right",
    kicker: "Carbon Intelligence",
    title: "NXMap",
    sections: [
      {
        description: [
          "Unify multi-language, multi-site emissions data in one guided workspace.",
          "Ingest information from ERPs, carbon tools, or live monitoring systems (BMS, EMS, IoT) without complex setups.",
          "Automated validations and verifiable reporting workflows keep sustainability, finance, and leadership aligned.",
        ],
      },
    ],
  },
  {
    id: "2_enhanced_features",
    image: "/sliders/nxmap/2_enhanced_features.png",
    imageAlt: "Enhanced Features",
    imagePosition: "left",
    title: "Enhanced, audit-friendly features",
    sections: [
      {
        description: [
          "Instant dashboards highlight hotspots, data gaps, and trends in seconds.",
          "Track emission factors, activity data, and approvals with granular permissions.",
          "ISO 14064-aligned logs build audit evidence automatically—no spreadsheets required.",
        ],
      },
    ],
  },
  {
    id: "3_audit_ready_reportings",
    image: "/sliders/nxmap/3_audit_ready_reportings.png",
    imageAlt: "Audit-Ready Reportings",
    imagePosition: "right",
    title: "Audit-ready reporting in days, not months",
    sections: [
      {
        description: [
          "Consolidate geographically dispersed datasets into a verified single source of truth.",
          "Automated checks flag anomalies while maintaining a full evidence trail.",
          "Deliver board-ready and regulator-ready outputs within a 14-day review window.",
        ],
      },
    ],
  },
  {
    id: "4_nxmap_supports",
    image: "/sliders/nxmap/4_nxmap_supports.png",
    imageAlt: "NXMap Supports",
    imagePosition: "left",
    title: "Ready for every disclosure",
    sections: [
      {
        description: [
          "Generate CFP/CFO reports, CBAM filings, carbon tax submissions, and EPDs from the same dataset.",
          "Built-in workflows map to CSRD, TCFD, and other evolving frameworks.",
          "Curated templates and approval routing keep stakeholders aligned and accountable.",
        ],
      },
    ],
  },
  {
    id: "5_customizable_ghg_emission_reports",
    image: "/sliders/nxmap/5_customizable_ghg_emission_reports.png",
    imageAlt: "Customizable GHG Emission Reports",
    imagePosition: "left",
    title: "Customisable GHG emission reporting",
    sections: [
      {
        description: [
          "Validated against ISO 14064-1, ISO 14064-2, and the GHG Protocol for global comparability.",
          "Information security is reinforced with ISO 27001 controls and continuous monitoring.",
          "Publish branded reports or export raw datasets for deeper analysis with partners.",
        ],
      },
    ],
  },
];

// Apply themes to slides
export const nxmapSlides = nxmapSlidesData.map((slide, index) => {
  // Alternate between themes for variety
  const theme =
    index % 3 === 0 ? "default" : index % 3 === 1 ? "emerald" : "sky";
  return applyTheme(slide, theme, "blue");
});
